import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { format } from 'date-fns';
import { DateUtilService } from 'gung-common';
import { RenderFilter } from '../types';

@Component({
    selector: 'lib-filter-between-date-time-range',
    templateUrl: './filter-between-date-time-range.component.html',
    styleUrl: './filter-between-date-time-range.component.css',
    standalone: false
})
export class FilterBetweenDateTimeRangeComponent {
  protected dateUtilService = inject(DateUtilService);
  
  @Input() public renderFilter: RenderFilter;
  @Input() showTodayDate: boolean = true;

  @Output() selectDateTimeRange = new EventEmitter<string[]>();

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minHour: number = null;
  minMinute: number = null;
  maxHour: number = null;
  maxMinute: number = null;

  ngOnInit(): void {
    const min = Math.min(
      ...this.renderFilter.valueList
        .filter(v => v.valueId && v.valueId.trim() !== '' && !isNaN(v.valueId as any))
        .map(v => parseFloat(v.valueId))
    ).toString();
    const minDate = this.dateUtilService.parseDate(min.padStart(6, '0'), 'yyMMddHHmm');
    this.minDate = { year: minDate.getFullYear(), month: minDate.getMonth() + 1, day: minDate.getDate() };

    const max = Math.max(
      ...this.renderFilter.valueList
        .filter(v => v.valueId && v.valueId.trim() !== '' && !isNaN(v.valueId as any))
        .map(v => parseFloat(v.valueId))
    ).toString();
    const maxDate = this.dateUtilService.parseDate(max.padStart(6, '0'), 'yyMMddHHmm');
    this.maxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
  }

  emitDateTimeRange(): void {
    const from = new Date(
      this.minDate.year,
      this.minDate.month - 1,
      this.minDate.day,
      this.minHour != null ? this.minHour : 0,
      this.minMinute != null ? this.minMinute : 0
    );
  
    const to = new Date(
      this.maxDate.year,
      this.maxDate.month - 1,
      this.maxDate.day,
      this.maxHour != null ? this.maxHour : 23,
      this.maxMinute != null ? this.maxMinute : 59
    );
    
    const formattedFrom = format(from, 'yyMMddHHmm');
    const formattedTo = format(to, 'yyMMddHHmm');
    this.selectDateTimeRange.emit([formattedFrom, formattedTo]);
  }

  get today(): NgbDateStruct {
    const currentDate = new Date();
    return {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate()
    };
  }

  selectTodayMinDate(): void {
    this.minDate = this.today;
    this.emitDateTimeRange();
  }

  selectTodayMaxDate(): void {
    this.maxDate = this.today;
    this.emitDateTimeRange();
  }

  validateHour(type: 'min' | 'max') {
    const value = type === 'min' ? this.minHour : this.maxHour;
    if (value != null && (value < 0 || value > 23)) {
      if (type === 'min') {
        this.minHour = null;
      } else {
        this.maxHour = null;
      } 
    }
  }
  
  validateMinute(type: 'min' | 'max') {
    const value = type === 'min' ? this.minMinute : this.maxMinute;
    if (value != null && (value < 0 || value > 59)) {
      if (type === 'min') {
        this.minMinute = null;
      } else {
        this.maxMinute = null;
      }
    }
  }
}
